import script from "./ReadMore.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadMore.vue?vue&type=script&setup=true&lang=ts"

import "./ReadMore.vue?vue&type=style&index=0&id=aee178fe&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aee178fe"]])

export default __exports__